






























































































































































































































































































































































































































































































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import BaseSuketCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketCard.vue";
import CommonSuket, { EnSuketCategory } from "@/services/CommonSuket";
import BaseSuketTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketTabPage";
import StoreSuketSkbpm from "@/store/modules/SuketSkbpm";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { storeDokter } from "@/store/modules/dokter";
import { getAge, formatDMYDate } from "@/utility/DateUtils";
import pdf from "vue-pdf";

interface TujuanOption {
  kode: string;
  label: string;
  icd10: string;
  hint: string;
}

@Component({
  components: {
    CardModalTtd,
    BaseSuketCard,
    pdf
  }
})
export default class SuketSkbpmTabPage extends BaseSuketTabPage {
  @Prop() declare readonly register: string | number;

  // SKBPM diterbitkan di Poli Umum/MCU/Okupasi/VCT mana pun → izinkan di
  // seluruh unit; kunci read-only tetap dari edit-window halaman (48 jam).
  allowedUnit = ["*"];
  suketSvc = new CommonSuket(EnSuketCategory.Skbpm);
  suketStore = StoreSuketSkbpm;

  register_id = this.register;
  pasien_rm = this.pasien.rm;
  unit_id = this.user.unit_id;
  nama = this.pasien.nama;
  surat_date = new Date();
  signee_user_id = this.user.id;
  creator_user_id = this.user.id;
  alamat_type = "ktp";

  tujuan: any = {
    kode: null,
    label: null,
    icd10: null,
    spesifik: null,
    pihak_penerima: null,
    no_surat_permintaan: null
  };
  anamnesis: any = {
    keluhan_utama: null,
    rpd: null,
    riwayat_penyakit_menular: null,
    riwayat_pengobatan: null,
    alergi: null,
    kontak_tbc: null,
    faktor_risiko: null,
    riwayat_bepergian: null
  };
  fisik: any = {
    kesadaran: "Compos mentis",
    td_sistolik: null,
    td_diastolik: null,
    nadi: null,
    napas: null,
    suhu: null,
    spo2: null,
    bb: null,
    tb: null,
    imt: null,
    status_generalis: null
  };
  lab: any = {
    hiv: { hasil: null, interpretasi: null },
    hbsag: { hasil: null, interpretasi: null },
    hcv: { hasil: null, interpretasi: null },
    vdrl: { hasil: null, interpretasi: null },
    tbc_gejala: null,
    tbc_interpretasi: null,
    tifoid: { hasil: null, interpretasi: null },
    parasit_usus: { hasil: null, interpretasi: null },
    lain: null
  };
  radiologi: any = { thorax: null };
  konseling: any = { pretest_hiv: false, postest_hiv: false, konselor: null };
  consent: any = {
    pemeriksaan: false,
    vct_hiv: false,
    disclosure: false,
    disclosure_hiv: false
  };
  kesimpulan: any = null;
  kesimpulan_catatan: any = null;
  diagnosis_tambahan: any = null;
  masa_berlaku_bulan: any = 3;

  openPanels = [0, 2, 3, 6];
  saving = false;
  loadedRatio = 0;
  validasi = [v => !!v || "*Kolom ini harus diisi"];

  tujuanOptions: TujuanOption[] = [
    {
      kode: "TJ-01",
      label: "TJ-01 — Pra-kerja / Karyawan Baru",
      icd10: "Z02.1",
      hint: "Panel: HIV, HBsAg, Anti-HCV, VDRL, TBC (anamnesis + foto toraks)"
    },
    {
      kode: "TJ-02",
      label: "TJ-02 — Berkala Karyawan (MCU Tahunan)",
      icd10: "Z02.79",
      hint: "Panel: HBsAg, TBC (anamnesis) — sesuaikan profesi"
    },
    {
      kode: "TJ-03",
      label: "TJ-03 — Pendaftaran Sekolah / Asrama / Pesantren",
      icd10: "Z02.0",
      hint: "Panel: HBsAg, TBC; Hep A & parasit usus kondisional"
    },
    {
      kode: "TJ-04",
      label: "TJ-04 — Pendaftaran Nikah (Calon Pengantin)",
      icd10: "Z31.41 + Z02.7",
      hint: "Panel: HIV, HBsAg, VDRL, Thalassemia (skrining), TBC"
    },
    {
      kode: "TJ-05",
      label: "TJ-05 — Visa / Imigrasi / Izin Tinggal",
      icd10: "Z02.89",
      hint: "Panel: HIV, HBsAg, VDRL, TBC (foto toraks + IGRA bila perlu)"
    },
    {
      kode: "TJ-06",
      label: "TJ-06 — SIM / Izin Mengemudi Profesional",
      icd10: "Z02.4",
      hint: "Panel: TBC (foto toraks)"
    },
    {
      kode: "TJ-07",
      label: "TJ-07 — Atlet / Olahraga",
      icd10: "Z02.5",
      hint: "Panel: HBsAg, Anti-HCV; HIV kondisional kontak sport"
    },
    {
      kode: "TJ-08",
      label: "TJ-08 — Asuransi",
      icd10: "Z02.6",
      hint: "Panel: sesuai permintaan asuransi (HIV/HBsAg/HCV/VDRL)"
    },
    {
      kode: "TJ-09",
      label: "TJ-09 — Food Handler / Sertifikat Laik Higiene",
      icd10: "Z02.79 + Z11.3",
      hint: "Panel: Tifoid, HBsAg, Hep A, parasit usus, TBC"
    },
    {
      kode: "TJ-10",
      label: "TJ-10 — Tenaga Kesehatan / Nakes Baru",
      icd10: "Z02.1",
      hint: "Panel: HIV, HBsAg, Anti-HCV, VDRL, TBC, Rubella (kondisional)"
    },
    {
      kode: "TJ-11",
      label: "TJ-11 — Adopsi / Pengasuhan Anak",
      icd10: "Z02.82",
      hint: "Panel: HIV, HBsAg, Anti-HCV, VDRL, TBC"
    },
    {
      kode: "TJ-12",
      label: "TJ-12 — Lainnya (uraikan di Tujuan Spesifik)",
      icd10: "Z02.79",
      hint: "Panel custom ditentukan DPJP"
    }
  ];

  interpretasiOptions = [
    "Non-Reaktif",
    "Reaktif",
    "Negatif",
    "Positif",
    "Borderline",
    "Tidak Diperiksa"
  ];
  tbcInterpretasiOptions = [
    "Tidak ada bukti TBC aktif",
    "Tersangka TBC — rujuk",
    "TBC aktif — rujuk"
  ];
  kesimpulanOptions = [
    "MEMENUHI SYARAT",
    "MEMENUHI SYARAT DENGAN CATATAN",
    "MEMERLUKAN EVALUASI LANJUT",
    "TIDAK MEMENUHI SYARAT"
  ];
  yaTidakOptions = ["Ya", "Tidak"];
  skriningFields = [
    { key: "hiv", label: "HIV (Anti-HIV)" },
    { key: "hbsag", label: "HBsAg *" },
    { key: "hcv", label: "Anti-HCV" },
    { key: "vdrl", label: "VDRL / TPHA" }
  ];

  get pasien() {
    return storePasien.identitasPasien;
  }

  get user() {
    return userModule.user;
  }

  get listDokter() {
    return storeDokter.list;
  }

  get umur() {
    return this.pasien.tgl_lahir
      ? getAge(formatDMYDate(this.pasien.tgl_lahir))
      : "-";
  }

  get imtKet() {
    const v = Number(this.fisik.imt);
    if (!v) return "";
    if (v >= 30) return "Obesitas";
    if (v >= 25) return "Overweight";
    if (v >= 18.5) return "Normal";
    return "Underweight";
  }

  get selectedTujuan(): TujuanOption | null {
    return this.tujuanOptions.find(t => t.kode === this.tujuan.kode) || null;
  }

  get tujuanIcd10() {
    return this.selectedTujuan ? this.selectedTujuan.icd10 : "";
  }

  get tujuanPanelHint() {
    return this.selectedTujuan ? this.selectedTujuan.hint : "";
  }

  get reactiveLabWarning() {
    const reaktif = ["reaktif", "positif"];
    const serologi = ["hiv", "hbsag", "hcv", "vdrl"].some(k => {
      const i = (this.lab[k].interpretasi || "").toLowerCase();
      return reaktif.includes(i);
    });
    const tbcAktif = ["Tersangka TBC — rujuk", "TBC aktif — rujuk"].includes(
      this.lab.tbc_interpretasi
    );
    const tambahan = ["tifoid", "parasit_usus"].some(k => {
      const i = (this.lab[k].interpretasi || "").toLowerCase();
      return reaktif.includes(i);
    });
    return serologi || tbcAktif || tambahan;
  }

  get catatanRules() {
    if (this.kesimpulan && this.kesimpulan !== "MEMENUHI SYARAT") {
      return [
        v => (!!v && v.length >= 50) || "Wajib diisi minimal 50 karakter"
      ];
    }
    return [];
  }

  get alamatOptions() {
    const opts = [
      { id: "ktp", name: this.pasien.alamat, category: "Alamat KTP" }
    ];
    if (this.pasien.alamat_domisili) {
      opts.push({
        id: "domisili",
        name: this.pasien.alamat_domisili,
        category: "Alamat Domisili"
      });
    }
    return opts;
  }

  get pdfUrl() {
    return this.dataSuket
      ? this.getSuketPdfUrl(EnSuketCategory.Skbpm, this.dataSuket.id)
      : null;
  }

  get input() {
    return {
      register_id: this.register_id,
      pasien_rm: this.pasien_rm,
      unit_id: this.unit_id,
      content: {
        alamat_type: this.alamat_type,
        tujuan: this.tujuan,
        anamnesis: this.anamnesis,
        fisik: this.fisik,
        lab: this.lab,
        radiologi: this.radiologi,
        konseling: this.konseling,
        consent: this.consent,
        kesimpulan: this.kesimpulan,
        kesimpulan_catatan: this.kesimpulan_catatan,
        diagnosis_tambahan: this.diagnosis_tambahan,
        masa_berlaku_bulan: Number(this.masa_berlaku_bulan) || 3
      },
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id
    };
  }

  get canSign() {
    return this.user.id == this.signee_user_id;
  }

  mounted() {
    this.hydrate(this.dataSuket);
  }

  hydrate(d: any) {
    this.register_id = d?.register_id || this.register;
    this.pasien_rm = d?.pasien_rm || this.pasien.rm;
    this.unit_id = d?.unit_id || this.user.unit_id;
    this.nama = this.pasien.nama;
    this.surat_date = d?.surat_date || new Date();
    this.signee_user_id = d?.signee_user_id || this.user.id;
    this.creator_user_id = d?.creator_user_id || this.user.id;
    this.alamat_type = d?.content?.alamat_type || "ktp";

    const c = d?.content;
    if (c) {
      this.tujuan = { ...this.tujuan, ...(c.tujuan || {}) };
      this.anamnesis = { ...this.anamnesis, ...(c.anamnesis || {}) };
      this.fisik = { ...this.fisik, ...(c.fisik || {}) };
      this.lab = {
        ...this.lab,
        ...(c.lab || {}),
        hiv: { ...this.lab.hiv, ...((c.lab && c.lab.hiv) || {}) },
        hbsag: { ...this.lab.hbsag, ...((c.lab && c.lab.hbsag) || {}) },
        hcv: { ...this.lab.hcv, ...((c.lab && c.lab.hcv) || {}) },
        vdrl: { ...this.lab.vdrl, ...((c.lab && c.lab.vdrl) || {}) },
        tifoid: { ...this.lab.tifoid, ...((c.lab && c.lab.tifoid) || {}) },
        parasit_usus: {
          ...this.lab.parasit_usus,
          ...((c.lab && c.lab.parasit_usus) || {})
        }
      };
      this.radiologi = { ...this.radiologi, ...(c.radiologi || {}) };
      this.konseling = { ...this.konseling, ...(c.konseling || {}) };
      this.consent = { ...this.consent, ...(c.consent || {}) };
      this.kesimpulan = c.kesimpulan || null;
      this.kesimpulan_catatan = c.kesimpulan_catatan || null;
      this.diagnosis_tambahan = c.diagnosis_tambahan || null;
      this.masa_berlaku_bulan = c.masa_berlaku_bulan || 3;
    }
  }

  setImt() {
    const bb = Number(this.fisik.bb);
    const tb = Number(this.fisik.tb);
    if (bb > 0 && tb > 0) {
      this.fisik.imt = (bb / Math.pow(tb / 100, 2)).toFixed(2);
    } else {
      this.fisik.imt = null;
    }
  }

  @Watch("fisik.bb")
  watchBb() {
    this.setImt();
  }

  @Watch("fisik.tb")
  watchTb() {
    this.setImt();
  }

  @Watch("tujuan.kode")
  watchTujuan(val: string) {
    const opt = this.tujuanOptions.find(t => t.kode === val);
    if (opt) {
      this.tujuan.label = opt.label.replace(/^[^—]*—\s*/, "");
      this.tujuan.icd10 = opt.icd10;
    }
  }

  @Watch("dataSuket")
  changeDataSuket(val: any) {
    this.hydrate(val);
  }

  save() {
    if (this.saving) return;

    // Honesty guard (mirror backend): kesimpulan wajib; bila ≠ "MEMENUHI
    // SYARAT" wajib justifikasi ≥ 50 karakter.
    if (!this.tujuan.kode) {
      appModule.sendErrorAlert("Tujuan pemeriksaan wajib dipilih");
      return;
    }
    if (!this.kesimpulan) {
      appModule.sendErrorAlert("Kesimpulan medis wajib diisi");
      return;
    }
    if (
      this.kesimpulan !== "MEMENUHI SYARAT" &&
      (this.kesimpulan_catatan || "").length < 50
    ) {
      appModule.sendErrorAlert(
        "Justifikasi klinis wajib diisi minimal 50 karakter bila kesimpulan bukan MEMENUHI SYARAT"
      );
      return;
    }

    this.saving = true;
    const action = this.dataSuket
      ? this.suketSvc.update(this.dataSuket.id, this.input)
      : this.suketSvc.create(this.input);

    action
      .then(() => {
        if (this.canSign) {
          this.showSignatureModal();
        }
        appModule.NoticeDelay("Berhasil Simpan SKBPM");
        this.close();
        StoreSuketSkbpm.getSuketByRegister(this.register);
      })
      .finally(() => {
        this.saving = false;
      });
  }

  close() {
    this.expandInput = false;
  }
}
